import { Flex } from '@revolut-internal/ui-kit'

import { CustomPlaceholder as Placeholder } from 'modules/Monitoring/components/Placeholder/Placeholder'

type ErrorFallbackProps = {
  resetError: () => void
}

export const ErrorFallback = ({ resetError }: ErrorFallbackProps) => (
  <Flex
    bg="layout-background"
    color="foreground"
    height="100vh"
    width="100vw"
    alignItems="center"
    justifyContent="center"
  >
    <Placeholder
      title="Something went wrong"
      description="We’re on it. Please try again or contact support."
      icon="ExclamationTriangle"
      action={{
        name: 'Try again',
        onClick: resetError,
      }}
    />
  </Flex>
)
